import { Container } from '@clearcover/atlas';
import { VersionedObjectDiff } from '@clearcover/core-app-types';
import { MultiLinePolicy } from '@clearcover/core-app-types/dist/endpoints/getPolicy/multiLinePolicy';
import { formatDiff } from 'Policies/components/PolicyActivities/Common/Common';
import { CardSectionInfoPairs } from 'Shared/components';
import React, { FC } from 'react';

export type DiscountChangeDetailsDiff = {
  diff: VersionedObjectDiff<MultiLinePolicy>;
};

export const DiscountChangeDetails: FC<DiscountChangeDetailsDiff> = ({
  diff,
}) => {
  return (
    <div data-testid="multi-line-discount-details">
      <Container>
        <h4>Multi-Line Discount</h4>
        <CardSectionInfoPairs
          headers={['Other lines insured']}
          data={[formatDiff(diff.old?.type, diff.new?.type)]}
        />
      </Container>
    </div>
  );
};
